import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import sendIcon from '../../../images/send-icon.svg';
import {
  SEND_BUTTON_SIZES,
  SEND_BUTTON_DEFAULT_PROPS
} from './constants';

const SendButton = ({
  onClick,
  disabled = SEND_BUTTON_DEFAULT_PROPS.disabled,
  loading = SEND_BUTTON_DEFAULT_PROPS.loading,
  size = SEND_BUTTON_DEFAULT_PROPS.size,
  className = SEND_BUTTON_DEFAULT_PROPS.className
}) => {
  const [isPressed, setIsPressed] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const { t } = useTranslation();

  const handleClick = (e) => {
    if (disabled || loading) return;
    
    // Activate stunning animation
    setIsActive(true);
    
    if (onClick) onClick(e);
  };

  const handleMouseDown = () => {
    if (!disabled && !loading) {
      setIsPressed(true);
    }
  };

  const handleMouseUp = () => {
    setIsPressed(false);
  };

  const handleMouseLeave = () => {
    setIsPressed(false);
  };

  // Reset active state when loading finishes
  useEffect(() => {
    if (!loading && isActive) {
      const timer = setTimeout(() => {
        setIsActive(false);
      }, 2000); // Keep active for 2 seconds after click
      
      return () => clearTimeout(timer);
    }
  }, [loading, isActive]);

  const sizeClasses = {
    [SEND_BUTTON_SIZES.SMALL]: 'send-button--small',
    [SEND_BUTTON_SIZES.MEDIUM]: 'send-button--medium',
    [SEND_BUTTON_SIZES.LARGE]: 'send-button--large'
  };

  return (
    <button
      className={`
        send-button 
        ${sizeClasses[size]} 
        ${disabled ? 'send-button--disabled' : ''} 
        ${loading ? 'send-button--loading' : ''} 
        ${isPressed ? 'send-button--pressed' : ''} 
        ${isActive ? 'send-button--active' : ''} 
        ${className}
      `.trim()}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      disabled={disabled || loading}
      type="button"
      aria-label={t('actions.sendMessage')}
    >
      {/* Flying plane icon with beautiful animations */}
      <div className="send-button__icon-container">
        <img
          src={sendIcon}
          alt={t('actions.send')}
          className="send-button__icon"
        />
        
        {/* Flying trail effect when loading */}
        {loading && (
          <div className="send-button__flying-trail">
            <div className="send-button__trail-dot" />
            <div className="send-button__trail-dot" />
            <div className="send-button__trail-dot" />
            <div className="send-button__trail-dot" />
          </div>
        )}
      </div>
    </button>
  );
};

export default SendButton;
